export default __webpack_public_path__ + "images/GettingBy.v-3f3a2fcbbaa33b8c290243e360b3a85a.svg";